export const DEFAULT_TITLE = "Что-то пошло не так";
export const DEFAULT_ACTION_TEXT = "Понятно";
